module.exports = __webpack_public_path__ + "app-static/img/icon-dsl.8eab6dc2.png";